// import axios from 'axios';
import axiosAuth from "@/services/axios";
import { isRequestCancelled } from "@/utils/cancelableRequest";

class BaseService {
  get<T = unknown>(url: string, data?: unknown) {
    return axiosAuth.get(url, {
      data,
    });
  }

  post<T = unknown>(url: string, data: Record<string, any>, config: Record<string, any> = {}) {
    const params = { ...data };

    const urlObj = new URL(window.location.href);
    const paramsUrl = urlObj.searchParams;

    const token = paramsUrl.get("token");
    if (token) {
      params.token = token;
    }

    const account = paramsUrl.get("account");
    if (account) {
      params.account_slug = account;
      params.account = account;
    }

    const game = paramsUrl.get("game");
    if (game) {
      params.game = game;
    }

    const lang = paramsUrl.get("lang");
    if (lang) {
      params.lang = lang;
    }

    const isRetail = paramsUrl.get("is_retail");
    if (isRetail) {
      params.is_retail = isRetail;
    }

    const adminUserId = paramsUrl.get("admin_user_id");
    if (adminUserId) {
      params.admin_user_id = adminUserId;
    }

    const currency = paramsUrl.get("currency");
    if (currency) {
      params.currency = currency;
    }

    return axiosAuth.post<T>(url, params, {
      headers: {
        lang: lang || 'en', // Default to 'en' if lang is not provided
        'x-timeZone': Intl.DateTimeFormat().resolvedOptions().timeZone
      },
      ...config,
    });
  }

  async postData<T = unknown>(
    url: string,
    data: Record<string, any>,
    config: Record<string, any> = {},
  ): Promise<T | null> {
    try {
      const res = await this.post<T>(url, data, config);
      return res.data;
    } catch (err) {
      if (isRequestCancelled(err)) {
        throw err;
      }
      console.log(err);
      return null;
    }
  }

  put<T = unknown>(url: string, data: unknown) {
    return axiosAuth.put(url, data);
  }

  delete<T = unknown>(url: string) {
    return axiosAuth.delete(url);
  }
}

export default BaseService;
